// Autogenerated file
export const universalTransferDocumentTypesEnum = {
    InvoiceAndTransfer: "InvoiceAndTransfer",
    TransferOnly: "TransferOnly",
};
export const universalTransferDocumentTypes = [
    { label: "Счет-фактура + передаточный документ (статус 1)", value: "InvoiceAndTransfer" },
    { label: "Только передаточный документ (статус 2)", value: "TransferOnly" },
];
